import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import SmoothScroll from 'smooth-scroll';
import { v4 as uuidv4 } from 'uuid';
import Home from './pages/Home/Home';
import Error404 from './pages/Error/404';
import { getCookie, setCookie, scrollTracker } from './common/utils';
import './global.scss';
import './fonts.scss';

class App extends Component {
  componentDidMount = () => {
    let userID = getCookie('klickUUID');
    if (!userID) {
      userID = uuidv4();
      setCookie('klickUUID', userID, 365);
    }
    window.gtag('set', { klickUUID: userID });

    scrollTracker();

    window.smoothScroll = new SmoothScroll();
  };

  render = () => {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="*" component={Error404} />
        </Switch>
      </Router>
    );
  };
}

export default App;
